define.alias("shared/components/shared/wizard/cancel-button", "calendar/components/shared/wizard/cancel-button");